import React from 'react'
import { getTopBalance } from 'utils/api-routes-accounts'
import ReportTablePage from './ReportTablePage'
import { useFinanceObservable } from '../../hooks/useFinanceObservable'

const TopBalances = () => {
  const report = useFinanceObservable<any[]>(() => getTopBalance())

  return (
    <ReportTablePage
      title="Top Balances"
      rows={report.data || []}
      isLoading={report.loading}
      columns={[
        {
          name: 'Code',
          selector: (row) => row.account_code || row.code || '--',
        },
        {
          name: 'Account',
          selector: (row) => row.account_name || row.name || '--',
        },
        {
          name: 'Classification',
          selector: (row) => row.classification || '--',
        },
        { name: 'Balance', selector: (row) => row.balance || 0 },
      ]}
    />
  )
}

export default TopBalances
